import Row from "@Containers/components/Row";
import React from "react";
import generateEnglishAlphabet from "@Pages/countryPage/functions/generateEnglishAlphabet";
import AlphabetCharacterType from "@Pages/countryPage/types/AlphabetCharacter.type";

type SeatHeaderProps = {
    corridorIndex: number
    seatColumnLength: number
    displayCorridors: boolean
}

function SeatHeader({corridorIndex, seatColumnLength, displayCorridors}: SeatHeaderProps) {
    const alphabet = generateEnglishAlphabet();
    const getLettersForSeatRowCount = () => {
        if (displayCorridors) {
            return [
                ...alphabet.slice(0, corridorIndex),
                ...alphabet.slice(corridorIndex - 1, seatColumnLength - 1),
            ]
        }

        return alphabet.slice(0, seatColumnLength)
    }

    const getDisplayedLetter = (letter: AlphabetCharacterType, index: number) => {
        if (displayCorridors) {
            return index !== corridorIndex ? letter.letter : ''
        }

        return letter.letter
    }

    return (
        <Row justify>
            {getLettersForSeatRowCount().map((letter, index) => (
                <span key={index} className="gb--seat-picker-seat-label">
                    {getDisplayedLetter(letter, index)}
                </span>
            ))}
        </Row>
    );
}

export default SeatHeader;